import React from "react";
import { Link } from "react-router-dom";
import { Avatar, Box, Button, Chip, IconButton, LinearProgress, TableCell, TableRow, Tooltip, Typography } from "@material-ui/core";
import { CheckCircleOutline, MoreHoriz, PermIdentityOutlined, PhoneOutlined, VisibilityOutlined } from "@material-ui/icons";
import useStyles from "@jumbo/Dashboards/FormBuilder/recordListStyles";
import { dateText } from "../FormTickets/utils";

export const participantName = (record, privacyMode) => privacyMode ? "شرکت‌کننده" : record.owner?.fullName || "کاربر حذف شده";
export const personnelCode = (record, privacyMode) => {
  const code = record.owner?.personnelCode;
  return code == null ? "—" : privacyMode ? `**${String(code).slice(2)}` : code;
};

export default function FormInputListItem({ record, form, privacyMode, mobile, busy, onMenu }) {
  const classes = useStyles();
  const name = participantName(record, privacyMode);
  const participant = <Box className={classes.participant}>
    <Avatar className={classes.avatar} aria-hidden="true">{name.trim().charAt(0)}</Avatar>
    <Box>
      <Typography component="span" className={classes.participantName}>{name}</Typography>
      <Typography component="span" className={classes.secondary}>کد پرسنلی: <bdi>{personnelCode(record, privacyMode)}</bdi></Typography>
    </Box>
  </Box>;
  const contact = <Box className={classes.contact}>
    <Typography component="p" variant="body2"><PermIdentityOutlined /><span className={classes.digits} dir="ltr" title="کد ملی">{privacyMode ? "—" : record.owner?.nationalCode || "—"}</span></Typography>
    <Typography component="p" variant="body2"><PhoneOutlined /><span className={classes.digits} dir="ltr" title="شماره تماس">{privacyMode ? "—" : record.owner?.phone || "—"}</span></Typography>
  </Box>;
  const correctField = (record.fields || []).find(field => field.title === "پاسخ های صحیح" && !field.rightAnswer);
  const totalField = (record.fields || []).find(field => field.title === "کل پاسخ ها" && !field.rightAnswer);
  const correct = Number(correctField?.userInput);
  const total = Number(totalField?.userInput);
  const hasScore = form?.type === "Exam" && correctField && totalField &&
    Number.isFinite(correct) && correct >= 0 && Number.isFinite(total) && total >= 0;
  const progress = total > 0 ? Math.min(100, Math.max(0, correct / total * 100)) : 0;
  const registrationLabel = form?.confirmation === "QRCode" ? record.attended ? "مصرف شده" : "مصرف نشده" : "ثبت شده";
  const result = hasScore ? <Box className={classes.progress}>
    <Typography className={classes.progressLabel}>{correct.toLocaleString("fa-IR")} از {total.toLocaleString("fa-IR")} پاسخ صحیح</Typography>
    <LinearProgress variant="determinate" value={progress} aria-label={`نتیجه آزمون ${name}`} className={`${classes.progressTrack} ${classes.progressComplete}`} />
    <Typography component="span" className={classes.secondary}>نتیجه ثبت‌شده آزمون</Typography>
  </Box> : form?.type === "Exam" ? <Typography className={classes.secondary}>نتیجه آزمون موجود نیست</Typography> :
    <Chip size="small" icon={<CheckCircleOutline />} label={registrationLabel}
      className={`${classes.status} ${form?.confirmation === "QRCode" && !record.attended ? classes.inProgress : classes.submitted}`} />;
  const timing = <Box className={classes.timing}>
    <Box><Typography component="span" className={classes.secondary}>تاریخ ثبت</Typography><Typography component="span" className={classes.timeValue}>{dateText(record.createdAt)}</Typography></Box>
    {record.updatedAt && <Box><Typography component="span" className={classes.secondary}>آخرین به‌روزرسانی</Typography><Typography component="span" className={classes.timeValue}>{dateText(record.updatedAt)}</Typography></Box>}
  </Box>;
  const actions = <Box className={classes.actions}>
    <Button component={Link} to={`/formFillDetails/${record._id}`} variant="outlined" size="small" color="primary" startIcon={<VisibilityOutlined />} className={classes.viewButton}>نمایش پاسخ</Button>
    <Tooltip title="عملیات ورودی"><IconButton className={classes.moreButton} aria-label={`عملیات ورودی ${name}`} aria-haspopup="menu" disabled={busy} onClick={event => onMenu(event, record)}><MoreHoriz /></IconButton></Tooltip>
  </Box>;
  if (mobile) return <Box component="article" aria-label={`ورودی ${name}`} className={classes.mobileCard}>
    <Box className={classes.mobileCardHeader}>{participant}</Box>
    <Box className={classes.mobileCardBody}>{result}{contact}{timing}</Box>
    <Box className={classes.mobileCardFooter}>{actions}</Box>
  </Box>;
  return <TableRow>
    <TableCell>{participant}</TableCell><TableCell>{contact}</TableCell><TableCell>{result}</TableCell><TableCell>{timing}</TableCell><TableCell>{actions}</TableCell>
  </TableRow>;
}
